import { Ref, ref } from "@vue/composition-api";
import { Subject, InfoTypeSummeryItem } from "./model";
import { get_info_type_counters_for_entity } from "./api";
import { memoize_by } from "@/fp";

const counters: Ref<InfoTypeSummeryItem[]> = ref([]);

const _load_counters = memoize_by(
  (p: { subject: Subject; time_frame: string }) => p.subject.id + p.time_frame,
  async ({ subject, time_frame }) => {
    return await get_info_type_counters_for_entity(subject);
  }
);

const load_counters = async (subject: Subject, time_frame: string) => {
  const res = await _load_counters({ subject, time_frame });
  if (res.success) {
    counters.value = res.value;
  }
};

export const info_types_counters = {
  counters,
  load_counters,
};
